// pdp-shipping-calculator.js
// Cálculo de frete na página de produto.
// Se o carrinho estiver vazio, adiciona o produto por um instante só para a API de frete
// ter o que calcular e remove logo em seguida. Esse item temporário leva a propriedade
// oculta "_hc_temp": fica numa linha separada (não se mistura com o "Comprar" da cliente),
// não aparece no carrinho e, se a página fechar no meio, o hc-cart.js limpa depois.
(function () {
  "use strict";
  if (window.__hcPdpShipping) return;
  window.__hcPdpShipping = true;

  var SHIPPING_COUNTRY = "BR";

  var estimatorWrap = document.querySelector("[data-estimate-shipping-wrap]");
  var cepInput = document.getElementById("ShippingZip_" + (estimatorWrap ? estimatorWrap.getAttribute("data-id") : ""));
  var estimateBtn = document.querySelector("[data-action='estimate-shipping']");
  var responseRatesContainer = document.querySelector("[data-response-rates]");

  var running = null; // evita dois cálculos ao mesmo tempo

  function setFlag(on) {
    try {
      if (on) { sessionStorage.setItem("hc_temp_pending", "1"); localStorage.setItem("hc_temp_pending", "1"); }
      else { sessionStorage.removeItem("hc_temp_pending"); localStorage.removeItem("hc_temp_pending"); }
    } catch (e) {}
  }

  function saveCep(cep) {
    try {
      localStorage.setItem("shipping_cep", cep);
      localStorage.setItem("user_cep", cep);
    } catch (e) {}
  }
  function getSavedCep() {
    try { return localStorage.getItem("shipping_cep") || localStorage.getItem("user_cep") || ""; } catch (e) { return ""; }
  }

  // Estado (UF) pelo CEP. Usa o mesmo mapa do carrinho quando ele já carregou.
  function cepToUF(cep) {
    if (window.HCCart && window.HCCart.cepToUF) return window.HCCart.cepToUF(cep);
    var n = parseInt(String(cep).replace(/\D/g, "").slice(0, 5), 10);
    var r = [[1000,19999,"SP"],[20000,28999,"RJ"],[29000,29999,"ES"],[30000,39999,"MG"],[40000,48999,"BA"],[49000,49999,"SE"],[50000,56999,"PE"],[57000,57999,"AL"],[58000,58999,"PB"],[59000,59999,"RN"],[60000,63999,"CE"],[64000,64999,"PI"],[65000,65999,"MA"],[66000,68899,"PA"],[68900,68999,"AP"],[69000,69299,"AM"],[69300,69399,"RR"],[69400,69899,"AM"],[69900,69999,"AC"],[70000,72799,"DF"],[72800,72999,"GO"],[73000,73699,"DF"],[73700,76799,"GO"],[76800,76999,"RO"],[77000,77999,"TO"],[78000,78899,"MT"],[79000,79999,"MS"],[80000,87999,"PR"],[88000,89999,"SC"],[90000,99999,"RS"]];
    for (var i = 0; i < r.length; i++) if (n >= r[i][0] && n <= r[i][1]) return r[i][2];
    return "";
  }

  // Variação escolhida agora (o formulário do produto muda o id ao trocar tamanho/cor)
  function currentVariantId() {
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    var v = input && input.value;
    return v || window.currentProductVariantId;
  }

  function fetchCart() {
    return fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); });
  }

  function addTemporaryProduct() {
    var variantId = currentVariantId();
    if (!variantId) return Promise.reject("Variant ID não definido.");
    setFlag(true);
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: { _hc_temp: "1" } }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var item = data && data.items ? data.items[0] : data;
        if (!item || !item.key) throw new Error("Não foi possível preparar o cálculo.");
        return item.key;
      });
  }

  function removeTemporaryProduct(key, attempt) {
    attempt = attempt || 0;
    if (!key) { setFlag(false); return Promise.resolve(); }
    return fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) {
        if (!r.ok && attempt < 2) throw new Error("retry");
        setFlag(false);
      })
      .catch(function () {
        if (attempt < 2) {
          return new Promise(function (ok) { setTimeout(ok, 800); }).then(function () { return removeTemporaryProduct(key, attempt + 1); });
        }
        // fica marcado; o hc-cart.js remove na próxima página
      });
  }

  function fetchShippingRates(cep) {
    var uf = cepToUF(cep);
    var url = "/cart/shipping_rates.json?shipping_address[zip]=" + encodeURIComponent(cep) +
      "&shipping_address[country]=" + SHIPPING_COUNTRY +
      (uf ? "&shipping_address[province]=" + uf : "");
    return fetch(url, { credentials: "same-origin" }).then(function (response) {
      if (!response.ok) throw new Error("Erro na API de frete: " + response.status);
      return response.json();
    });
  }

  function displayShippingRates(rates) {
    if (!responseRatesContainer) return;
    if (!rates || rates.length === 0) {
      responseRatesContainer.innerHTML = "<p>Não encontramos opções de entrega para este CEP.</p>";
      return;
    }
    var html = '<ul class="shipping-rates-list" style="list-style:none; margin:0; padding:0;">';
    rates.forEach(function (rate) {
      var name = rate.name === "Local Delivery" ? "Motoboy" : (rate.name || "");
      var prazo = "";
      if (rate.delivery_days && Array.isArray(rate.delivery_days) && rate.delivery_days.length > 0) {
        var minDias = rate.delivery_days[0];
        var maxDias = rate.delivery_days[1] || minDias;
        prazo = minDias === maxDias ? "Entrega em até " + minDias + " dias úteis" : "Entrega em " + minDias + " a " + maxDias + " dias úteis";
      } else if (rate.delivery_range && Array.isArray(rate.delivery_range) && rate.delivery_range.length === 2) {
        prazo = "Entrega entre " + rate.delivery_range[0] + " e " + rate.delivery_range[1];
      } else if (rate.description) {
        prazo = rate.description;
      }
      var price = parseFloat(rate.price) === 0 ? "Grátis" : "R$ " + parseFloat(rate.price).toFixed(2).replace(".", ",");
      html += '<li class="shipping-option-container-pdp" style="border-bottom: 1px solid #eaeaea;">' +
        '<div class="shipping-option-header-pdp" style="display:flex; justify-content:space-between; align-items:center;">' +
        '<span class="shipping-name-pdp" style="font-weight:600; color:#333;">' + name + "</span>" +
        '<span class="shipping-price-pdp" style="font-weight:600; color:#333;">' + price + "</span></div>" +
        '<div class="shipping-delivery-pdp">' + prazo + "</div></li>";
    });
    html += "</ul>";
    responseRatesContainer.innerHTML = html;
  }

  function calculateShipping() {
    if (running) return running;
    var cep = getSavedCep().trim();
    if (cep && cepInput) cepInput.value = cep;
    if (!responseRatesContainer) return Promise.resolve();
    if (!cep) {
      responseRatesContainer.innerHTML = "<p>Digite seu CEP para calcular o frete.</p>";
      return Promise.resolve();
    }
    responseRatesContainer.innerHTML = "<p>Calculando...</p>";
    var tempKey = null;
    running = fetchCart()
      .then(function (cart) {
        if (cart.item_count === 0) return addTemporaryProduct().then(function (k) { tempKey = k; });
      })
      .then(function () { return fetchShippingRates(cep); })
      .then(function (ratesData) { displayShippingRates(ratesData.shipping_rates); })
      .catch(function (error) {
        console.error("Erro ao calcular frete:", error);
        responseRatesContainer.innerHTML = "<p>Não foi possível calcular agora. Confira o CEP e tente de novo.</p>";
      })
      .then(function () { return removeTemporaryProduct(tempKey); })
      .then(function () { running = null; }, function () { running = null; });
    return running;
  }

  function onCalc() {
    var cep = cepInput ? cepInput.value.trim() : "";
    if (cep) { saveCep(cep); calculateShipping(); }
    else alert("Por favor, digite um CEP válido.");
  }

  function init() {
    if (getSavedCep()) calculateShipping();
    if (estimateBtn) estimateBtn.addEventListener("click", onCalc);
    if (cepInput) {
      cepInput.addEventListener("keypress", function (e) {
        if (e.key === "Enter") { e.preventDefault(); onCalc(); }
      });
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
